<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="$store.getters.role == 1 || $store.getters.role == 2">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <!-- <div class="page-name">List Tickets</div> -->
                    <div class="page-name">User Tickets</div>
                    <button type="button" class="btn btn-secondary" v-on:click="exportTicket($event)">Export</button>
                </div>

                <div class="admin-page-content">
                    <!-- List Content Here -->
                    <!-- List Content Here -->
                    <div class="card">
                        <h5 class="card-header" style="background:#f5f5f5;">
                            <div class="">
                                <div class="three-filter">

                                    <div class="selectbox1">
                                        <VueCtkDateTimePicker range v-model="date_picker_dates"
                                                              :only-time="false"
                                                              :format="date_picker_options.inputFormat"
                                                              :formatted="date_picker_options.formatted"
                                                              :noClearButton="true"
                                                              :maxDate="date_picker_options.maxDate"
                                                              :custom-shortcuts="date_picker_options.customShortcuts"
                                                              @input="changeDatePickerDate()"
                                        ></VueCtkDateTimePicker>
                                        <span class="text-danger">{{datePickerError}}</span>
                                    </div>

                                    <!--<div class="selectbox1">-->
                                        <!--<datetime type="date"-->
                                                <!--v-model="ticketData.from_date"-->
                                                <!--:max-datetime="ticketData.to_date"-->
                                                <!--:format="ticketdate.format"-->
                                                <!--id="from-date"-->
                                                <!--placeholder="From Date"-->
                                                <!--v-validate="'required'"-->
                                                <!--name="From date">-->
        <!---->
                                        <!--</datetime>-->
                                        <!--<span v-if="errors.has('From date')" class="text-danger" >{{ errors.first('From date') }}</span>-->
                                        <!--&lt;!&ndash;:value-zone="'America/Los_Angeles'"-->
                                                <!--:zone="'America/Los_Angeles'" &ndash;&gt;-->
                                        <!--&lt;!&ndash;<span>{{ errors.first('from_date') }}</span>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<label class="text-danger" id="from-date-error" v-if="ticketDataError.from_date">{{ ticketDataError.from_date }}</label>&ndash;&gt;-->

                                    <!--</div>-->
                                    <!--<div class="selectbox1">-->
                                        <!--<datetime type="date"-->
                                                <!--v-model="ticketData.to_date"-->
                                                <!--:min-datetime="ticketData.from_date"-->
                                                <!--:format="ticketdate.format"-->
                                                <!--id="to-date"-->
                                                <!--v-validate="'required'"-->
                                                <!--name="To date"-->
                                                <!--placeholder="To Date"></datetime>-->
                                            <!--<span v-if="errors.has('To date')" class="text-danger" >{{ errors.first('To date') }}</span>-->
                                        <!--&lt;!&ndash;<label class="text-danger" v-if="ticketDataError.to_date">{{ ticketDataError.to_date }}</label>&ndash;&gt;-->
                                    <!--</div>-->

                                    <div class="selectbox1" style="display:none;">
                                        <datepicker class="" placeholder="Select Date" v-model="ticketData.date" :format="ticketdate.format">
                                        </datepicker>
                                        <!--<span v-if="errors.has('date')" class="text-danger" >{{ errors.first('date') }}</span>-->
                                    </div>
                                    <div class="selectbox1">
                                        <v-select v-model="selectedUser" name="user" placeholder="Type name here"
                                                label="name"
                                                :options="userOptions" class="" >
                                        </v-select>
                                    </div>
                                    <div class="selectbox1">
                                        <v-select v-model="selectedLocation" name="location" placeholder="Type location here"
                                                label="location_name"
                                                :options="locationOptions" class="" >
                                        </v-select>
                                        <span class="text-danger">{{locationError}}</span>
                                    </div>
                                </div>

                                <div class="selectbtn">

                                    <button type="button" class="btn btn-warning applybtn" v-on:click="loadUserTickets()">Apply Filter</button>
                                    <button type="button" class="btn btn-primary clearbtn" v-on:click="clearFilter()">Clear Filter</button>
                                </div>

                            </div>
                        </h5>
                        <div class="card-body">
                            <vue-good-table
                                    :columns="columns"
                                    :rows="rows"
                                    :line-numbers="true"
                                    :searchOptions="{enabled: true,placeholder:'Search by User'}"
                                    :sort-options="{
                                    enabled: true,

                                }">
                                :pagination-options="{
                                enabled: true,
                                mode: 'pages'
                                }"
                                ></vue-good-table>
                        </div>
                    </div>
                </div>



            </div>
        </template>
        <template v-else>
            <no-permission></no-permission>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import FrontFooter from '@/components/FrontFooter';
    import NoAccessPermission from '@/components/NoAccessPermission'
    import {HTTP} from '../http-common';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import Datepicker from 'vuejs-datepicker';
    import {Datetime} from 'vue-datetime'
    import vSelect from 'vue-select';
    import {commonMixins} from '../mixins/commonMixins';
    import 'vue-datetime/dist/vue-datetime.css';
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

    export default {
        name: "TicketPerDay",
        mixins: [commonMixins],
        components: {
            'app-footer':FrontFooter,
            'no-permission': NoAccessPermission,
            Datepicker,
            vSelect,
            datetime: Datetime,
            'vue-ctk-date-time-picker' : VueCtkDateTimePicker,
        },
        data() {
            return {

                columns: [
                    {
                        label: 'Number Handled By',
                        field: 'name',
                        filterable: false,
                    },
                    {
                        label: 'Location',
                        field: 'location_name',
                        filterable: false,
                    },
                    {
                        label: 'Number Per Day',
                        field: 'ticket_per_day',
                        filterable: false,
                        type:'number',
                    },
                    /*{
                        label: 'Customer Not In Queue',
                        field: 'customer_not_in_queue',
                        filterable: false,
                        type:'number',
                    },*/
                ],
                rows: [],
                ticketData:{
                    date:'',
                    user_id:'',
                    location_id:'',
                    from_date:'',
                    to_date:'',
                    flag:1,
                },
                ticketdate:{
                    format:'yyyy-MM-dd'
                },
                selectedUser:'',
                selectedLocation:'',
                date_picker_options: {
                    maxDate : '',
                    inputFormat: 'YYYY-MM-DD',
                    formatted: 'MMM DD, YYYY',//'YYYY-MM-DD',
                    customShortcuts : [
                        /* { label: 'Yesterday', value: '-day', isSelected: false },
                        { label: 'This Week', value: 'week', isSelected: false },
                        { label: 'Last Week', value: '-week', isSelected: false },
                        { label: 'This Month', value: 'month', isSelected: false },
                        { label: 'Last Month', value: '-month', isSelected: false }, */
                        { key: 'yesterday', label: 'Yesterday', value: '-day', isSelected: false },
                        { key: 'thisWeek', label: 'This Week', value: 'isoWeek', isSelected: false },
                        { key: 'lastWeek', label: 'Last Week', value: '-isoWeek', isSelected: false },
                        { key: 'thisMonth', label: 'This Month', value: 'month', isSelected: false },
                        { key: 'lastMonth', label: 'Last Month', value: '-month', isSelected: false },
                    ]
                },
                date_picker_dates: {
                    "start": "2019-03-06",
                    "end": "2019-03-27"
                },
                datePickerError : '',
                locationError : '',
            }
        },
        mounted:function(){
            let self = this;
            self.loadUser();
            self.loadLocations();

            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = today.getFullYear();
            today = yyyy + '-' + mm + '-' + dd;
            self.date_picker_dates = {
                start : today,
                end : today,
            };
            if (self.date_picker_dates.end === null) {
                self.date_picker_dates.end = self.date_picker_dates.start;
            }
            self.ticketData.from_date = self.date_picker_dates.start.split(' ')[0];
            self.ticketData.to_date = self.date_picker_dates.end.split(' ')[0];
            self.date_picker_options.maxDate = today;
            self.loadUserTickets();
        },
        watch: {
            selectedUser: function (user) {
                let self = this;

                if (self.selectedUser == null) {
                    self.ticketData.user_id = "";
                } else {
                    self.ticketData.user_id = self.selectedUser.id;
                }
            },
            selectedLocation: function (lcoation) {
                let self = this;

                if (self.selectedLocation == null) {
                    self.ticketData.location_id= "";
                } else {
                    self.locationError = '';
                    self.ticketData.location_id= self.selectedLocation.location_id;
                }
            },
        },
        methods: {
            clearFilter(){
                let self = this;
                self.selectedUser = '',
                self.selectedLocation = '',
                self.ticketData.date='';
                self.ticketData.user_id='';
                self.ticketData.location_id='';
                self.date_picker_dates.start = '';
                self.date_picker_dates.end = '';
                self.loadUserTickets();
            },
            changeDatePickerDate : function () {
                let self = this;
                self.datePickerError = '';
            },
            checkForm : function() {
                let checked = true;
                let self = this;
                if (self.ticketData.location_id == null 
                    || self.ticketData.location_id == "") {
                    self.locationError = "Please Select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                /*if (self.ticketData.user_id === null
                    || self.ticketData.user_id === "") {
                    self.locationError = "Please Select User";
                    if (checked) {
                        checked = false;
                    }
                }*/
                return checked;
            },
            loadUserTickets() {
                let self = this;
                if (self.date_picker_dates.end === null) {
                    self.date_picker_dates.end = self.date_picker_dates.start;
                }
                self.ticketData.from_date = self.date_picker_dates.start.split(' ')[0];
                self.ticketData.to_date = self.date_picker_dates.end.split(' ')[0];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                self.ticketData.flag=1;
                let ticketData = self.ticketData;
                HTTP.post('user/ticket',ticketData,config)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            self.rows = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        self.catchHandler(err, function() {

                        });
                    })
            },
            exportTicket : function (e) {
                let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                if (self.date_picker_dates.end === null) {
                    self.date_picker_dates.end = self.date_picker_dates.start;
                }
                self.ticketData.from_date = self.date_picker_dates.start.split(' ')[0];
                self.ticketData.to_date = self.date_picker_dates.end.split(' ')[0];
                let ticketData = self.ticketData;
                HTTP.post('ticketperday/export',ticketData,config)
                    .then(function (response) {
                        console.log(response);
                        if (response.data.code == 200) {
                            location.href = response.data.content.web;
                            // self.rows = response.data.content;

                            // self.totalRecords = response.data.content.totalRecords;
                        } 
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function() {

                        });
                        
                    })
            },

        },

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/TicketPerDay.vue